<mat-label class="subHeading">Rule Name</mat-label>
<input formControlName="rule_name" type="text" class="rule mt-2" />
